module.exports = __webpack_public_path__ + "img/acceptIcon.2403d1b1.svg";